import { useState } from "react";
import ORMfunctions from "../hooks/app/general";
import SearchModal from "../components/modals/Searchmodal";
import { useDispatch } from "react-redux";
import { setSelectedVehicle } from "../store/orm/userSession";

function ReservationButton(props: any) {
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);

  function openModal(): void {
    if (props.selectedcargroup) {
      dispatch(
        setSelectedVehicle({
          vehicleId: props.selectedcargroup,
          categories: props.selectedcargroup.split("+"),
        }),
      );
    }
    setShowModal(true);
  }

  function closeModal(): void {
    setShowModal(false);
  }

  return (
    <div>
      <button
        className={props.class ? props.class : "orm-button__cta"}
        onClick={() => openModal()}
      >
        {props.text ? props.text : ORMfunctions.i18n("cargroup/select")}
      </button>

      {showModal ? <SearchModal close={() => closeModal()} /> : <></>}
    </div>
  );
}

export default ReservationButton;
